import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaTimes } from "react-icons/fa";

import menuIcon from "../../images/icons/menu.svg";

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const switchLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    if (lng === "ar") {
      document.documentElement.dir = "rtl";
    } else {
      document.documentElement.dir = "ltr";
    }
  };

  useEffect(() => {
    if (i18n.language === "ar") {
      document.documentElement.dir = "rtl";
    } else {
      document.documentElement.dir = "ltr";
    }
  }, [i18n.language]);

  const navLinks = [
    { to: "#home", label: t("navbar.home") },
    { to: "#why-us", label: t("navbar.features") },
    { to: "#plans", label: t("navbar.services") },
    { to: "#our-works", label: t("navbar.works") },
    { to: "#contactus", label: t("navbar.contactus") },
  ];

  return (
    <nav className="container mx-auto w-full flex justify-between items-center bg-white/15 border border-primary rounded-20 backdrop-blur-[400px] my-6 px-6 py-3">
      <a href={"/"}>
        <img src="specter-single.svg" alt="Specter Logo" className="h-8" />
      </a>

      <div className="hidden md:flex items-center gap-6 text-xl font-normal">
        {navLinks.map((link, idx) => (
          <a
            key={idx}
            href={link.to}
            className="relative py-1 rounded-full transition-all duration-500
              after:content-[''] after:absolute after:left-1/2 after:-bottom-1
              after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-500
              hover:after:left-0 hover:after:w-full"
          >
            {link.label}
          </a>
        ))}
      </div>

      <div className="flex items-center gap-4">
        <div
          key={i18n.language}
          className="font-semibold cursor-pointer capitalize"
          onClick={() => switchLanguage(i18n.language === "en" ? "ar" : "en")}
        >
          {i18n.language === "en" ? "Ar" : "En"}
        </div>

        <button
          className="md:hidden flex items-center"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? (
            <FaTimes className="text-3xl" />
          ) : (
            <img src={menuIcon} alt="Menu" />
          )}
        </button>
      </div>

      {isOpen && (
        <div className="absolute top-16 left-0 w-full bg-main backdrop-blur-lg border border-primary rounded-b-20 flex flex-col items-center gap-4 py-6 z-50 md:hidden">
          {navLinks.map((link, idx) => (
            <Link
              key={idx}
              to={link.to}
              className="text-xl font-medium transition hover:text-primary"
              onClick={() => setIsOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
